import { Button, CircularProgress, Grid, Typography } from "@material-ui/core";
import { Form, Formik } from "formik";
import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { submitRegisterStages } from "../../redux/Login/LoginActions";
import Store from "../../redux/Store";
import Logo from "../../img/loginLogo.png";
import {
  InitialValues,
  validationSchema,
} from "../../validation/RegisterStagesValidation";
import RegisterFinelMessage from "./RegisterFinelMessage";
import RegisterStage1 from "./RegisterStage1";
import RegisterStage2 from "./RegisterStage2";
import RegisterStage3 from "./RegisterStage3";
import { utils } from "../../validation/ValidationFunctions";

import { setRegisterStage } from "../../redux/Login/LoginActionCreators";
const RegisterStages = ({
  registerStageNumber,
  register_address,
  Register_Mobile_Email,
  loading,
}) => {
  const history = useHistory();
  return (
    <>
      {registerStageNumber === 4 ? (
        <RegisterFinelMessage />
      ) : (
        <Formik
          initialValues={InitialValues}
          validationSchema={validationSchema}
          validateOnMount
          onSubmit={(values, props) => {
            submitRegisterStages({
              ...values,
              start_work_time: utils.now(values.start_work_time),
              end_work_time: utils.now(values.end_work_time),
            }).then((res) => {
              if (res) {
                props.resetForm();
              }
            });
          }}
        >
          {(formik) => {
            const stage1 = value1.some(
              (item) => formik.getFieldMeta([item]).error !== undefined
            );
            const stage2 = value2.some(
              (item) => formik.getFieldMeta([item]).error !== undefined
            );

            const checkPass = () => {
              if (formik.values.password === formik.values.confirm_password) {
                return true;
              }
              return false;
            };
            const check = checkPass();
            isNaN(Register_Mobile_Email)
              ? (formik.values.email = Register_Mobile_Email)
              : (formik.values.cellphone = Register_Mobile_Email);

            formik.values.address = register_address.address;
            formik.values.district = register_address.district;
            formik.values.city = register_address.city;
            formik.values.province = register_address.province;
            formik.values.country = "ایران";

            return (
              <Form>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{ height: "100vh", backgroundColor: "#F2F2F6" }}
                >
                  <Grid
                    container
                    item
                    justifyContent="center"
                    alignItems="center"
                    direction="column"
                    spacing={5}
                    xs={9}
                    sm={8}
                    md={registerStageNumber !== 3 ? 8 : 9}
                    lg={registerStageNumber !== 3 ? 7 : 9}
                    xl={registerStageNumber !== 3 ? 6 : 9}
                    style={{
                      backgroundColor: "white",
                      borderRadius: "20px",
                      boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                      paddingTop: "0%",
                      paddingBottom: "0%",
                    }}
                  >
                    <Grid
                      item
                      container
                      xs={12}
                      md={registerStageNumber !== 3 ? 10 : 11}
                      justifyContent="center"
                      style={{}}
                    >
                      <Grid item xs={12} container justifyContent="center">
                        <img src={Logo} alt="logo" />
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Typography color="textSecondary" variant="subtitle2">
                          لطفا برای تکمیل فرآیند ثبت نام فرم .
                          {registerStageNumber}/3 را پر نمایید .
                        </Typography>
                      </Grid>
                      {registerStageNumber === 1 ? (
                        <RegisterStage1 />
                      ) : registerStageNumber === 2 ? (
                        <RegisterStage2 />
                      ) : registerStageNumber === 3 ? (
                        <RegisterStage3 />
                      ) : (
                        history.push("/register")
                      )}
                      {registerStageNumber !== 3 ? (
                        <Grid
                          item
                          xs={12}
                          container
                          alignItems="center"
                          justifyContent="center"
                          direction="column"
                          spacing={2}
                          style={{ margin: "auto" }}
                        >
                          <Grid
                            item
                            xl={6}
                            style={{}}
                            container
                            lg={6}
                            md={9}
                            xs={10}
                          >
                            <Button
                              onClick={(e) => {
                                e.preventDefault();
                                Store.dispatch(
                                  setRegisterStage(registerStageNumber + 1)
                                );
                              }}
                              variant="contained"
                              color="primary"
                              fullWidth
                              disabled={
                                registerStageNumber === 1
                                  ? stage1 || !check
                                    ? true
                                    : false
                                  : registerStageNumber === 2
                                  ? stage2
                                    ? true
                                    : false
                                  : false
                              }
                            >
                              مرحله بعد
                            </Button>
                          </Grid>
                          {registerStageNumber !== 1 ? (
                            <Grid item container xl={6} lg={6} md={9} xs={10}>
                              <Button
                                onClick={() =>
                                  Store.dispatch(
                                    setRegisterStage(registerStageNumber - 1)
                                  )
                                }
                                variant="outlined"
                                color="primary"
                                fullWidth
                              >
                                مرحله قبل
                              </Button>
                            </Grid>
                          ) : null}
                        </Grid>
                      ) : (
                        <Grid
                          item
                          xs={5}
                          container
                          spacing={1}
                          style={{ margin: "auto" }}
                        >
                          <Grid item xs={12}>
                            <Button
                              disabled={!formik.isValid || loading}
                              variant="contained"
                              color="primary"
                              type="submit"
                              fullWidth
                            >
                              {!loading ? (
                                "  ثبت نام"
                              ) : (
                                <CircularProgress
                                  style={{
                                    color: "white",
                                    height: 24,
                                    width: 24,
                                  }}
                                />
                              )}
                            </Button>
                          </Grid>

                          <Grid item xs={12}>
                            <Button
                              onClick={() =>
                                Store.dispatch(
                                  setRegisterStage(registerStageNumber - 1)
                                )
                              }
                              variant="outlined"
                              color="primary"
                              fullWidth
                            >
                              مرحله قبل
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
                {/* </Grid> */}
              </Form>
            );
          }}
        </Formik>
      )}
    </>
  );
};

const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const {
    registerStageNumber,
    register_address,
    Register_Mobile_Email,
    loading,
  } = loginReducer;

  return {
    Register_Mobile_Email,
    register_address,
    registerStageNumber,
    loading,
  };
};
export default connect(mapStateToProps)(RegisterStages);
const value1 = [
  "cellphone",
  "email",
  "first_name",
  "last_name",
  "ssn",
  "password",
  "confirm_password",
];
const value2 = [
  "board_title",
  "phone",
  "office_number",
  "start_work_time",
  "end_work_time",
];
